import React from 'react';
import AddDocuments from './StartCalendar/AddDocuments';
import StartCalendar from './StartCalendar/StartCalendar';
import AddTopicModal from './StartCalendar/AddTopicModal';
import Notifications from './Notifications/Notifications';
import Notification from './Notifications/Notification';
import HighResolution from './HightResolution.js/HighResolution';
import ConsultResolution from './ConsultResolution/ConsultResolution';
import { Redirect, Switch } from 'react-router-dom';
import { ContentRoute } from 'src/_metronic/layout';
import { authentication } from '../Authentication';
import { useSelector } from 'react-redux';

const Track = () => {
	const user = useSelector((state) => state.auth.user);
	return (
		<Switch>
			<Redirect exact from="/seguimiento" to="/seguimiento/inicio" />
			<ContentRoute path="/seguimiento/inicio" component={StartCalendar} />
			{authentication.hasRole(
				[
					'ADMINISTRADOR GENERAL',
					'RESPONSABLE DE SEGUIMIENTO',
					'SISTEMA',
					'RESPONSABLE DE NEGOCIO',
				],
				user
			) ? (
				<>
					<ContentRoute
						path="/seguimiento/alta-resolucion"
						component={HighResolution}
					/>
					<ContentRoute
						path="/seguimiento/consultar-resolucion"
						component={ConsultResolution}
					/>
					<ContentRoute
						path="/seguimiento/resolucion/:id"
						component={HighResolution}
					/>
					<ContentRoute
						path="/seguimiento/inclusion-temas/:id"
						component={AddTopicModal}
					/>
					<ContentRoute
						path="/seguimiento/agregar-documentacion-resoluciones/:id"
						component={AddDocuments}
					/>
					<ContentRoute
						path="/seguimiento/notificaciones"
						component={Notifications}
					/>
					<ContentRoute
						path="/seguimiento/nueva-notificacion"
						component={Notification}
					/>
					<ContentRoute
						path="/seguimiento/notificacion/:id"
						component={Notification}
					/>
				</>
			) : (
				''
			)}
			{authentication.hasRole(
				['RESPONSABLE DE ORGANO COLEGIADO', 'ENLACE'],
				user
			) ? (
				<>
					{/*INICIO SUBMODULOS DE SEGUIMIENTO SOLO SIN ALTA DE RESOLUCION */}
					<ContentRoute
						path="/seguimiento/consultar-resolucion"
						component={ConsultResolution}
					/>
					<ContentRoute
						path="/seguimiento/resolucion/:id"
						component={HighResolution}
					/>
					<ContentRoute
						path="/seguimiento/inclusion-temas/:id"
						component={AddTopicModal}
					/>
					<ContentRoute
						path="/seguimiento/agregar-documentacion-resoluciones/:id"
						component={AddDocuments}
					/>
					{/*FIN SUBMODULOS DE SEGUIMIENTO SOLO SIN ALTA DE RESOLUCION */}
				</>
			) : (
				''
			)}
			{authentication.hasRole(['CONSULTA'], user) ? (
				<>
					{/*INICIO SUBMODULOS DE SEGUIMIENTO SOLO CONSULTA RESOLUCIONES */}
					<ContentRoute
						path="/seguimiento/consultar-resolucion"
						component={ConsultResolution}
					/>
					<ContentRoute
						path="/seguimiento/resolucion/:id"
						component={HighResolution}
					/>
					{/*FIN  SUBMODULOS DE SEGUIMIENTO SOLO CONSULTA RESOLUCIONES  */}
				</>
			) : (
				''
			)}
			{authentication.hasRole(['RESPONSABLE CASIA'], user) ? (
				<>
					{/*INICIO SOLO CONSULTA POR ID DE RESOLUCION  */}

					<ContentRoute
						path="/seguimiento/resolucion/:id"
						component={HighResolution}
					/>
					{/*FIN SOLO CONSULTA POR ID DE RESOLUCION  */}
				</>
			) : (
				''
			)}
		</Switch>
	);
};

export default Track;
